import { toastManager } from '@crm/entities/toast'
import { createFormApiErrorHandler } from '@crm/shared/lib'

import type { TFormInput } from './form.schema'
import type { FieldPath } from 'react-hook-form'

export const createDealFieldByPointer = {
  name: 'dealName',
  customerName: 'customerName',
  phone: 'phone',
  objectType: 'objectType',
  area: 'areaSquare',
  requestEssence: 'description',
  approximateBudget: 'budget',
  source: 'source',
  receivedAt: 'receivedAt',
} as const satisfies Record<string, FieldPath<TFormInput>>

export const handleCreateDealError = createFormApiErrorHandler<TFormInput>({
  fieldByPointer: createDealFieldByPointer,
  showToast: (title) => toastManager.onError({ title }),
})
